import React, { useState } from "react";
import PropTypes from "prop-types";
import * as S from "./CardActivateInsurance.Style";
import Button from "../core/Button/Button";

export const handleScrollSmooth = () => {
  const element = document.getElementsByName("Identificação");
  const offsetTop =
    element[0]?.getBoundingClientRect()?.top + window.scrollY - 200;
  window.scrollTo({ top: offsetTop, behavior: "smooth" });
};

const CardActivateInsurance = ({ CardActivateInsuranceItem }) => {
  const [activeCardSection, setActiveCardSection] = useState(
    CardActivateInsuranceItem
  );

  const handleButtonClick = (title) => {
    if (activeCardSection !== title) {
      setActiveCardSection(title);
    }
    setTimeout(handleScrollSmooth, 50);
  };

  return (
    <S.CardActivateInsuranceContainer>
      <S.CardActivateInsuranceContentGroup>
        {CardActivateInsuranceItem.map(
          ({ title, icon, buttonText, link, textlink }) => (
            <S.CardActivateInsuranceContent
              tabCount={CardActivateInsuranceItem.length}
              key={title}
              isActive={activeCardSection === title}
            >
              <S.CardActivateInsuranceIconWithTitle>
                <span
                  style={{
                    color: `${
                      activeCardSection === title ? "#fff" : "#6F7C87"
                    }`,
                  }}
                >
                  {icon}
                </span>
                <S.CardActivateInsuranceTitle>
                  {title}
                </S.CardActivateInsuranceTitle>
              </S.CardActivateInsuranceIconWithTitle>

              <S.CardActivateInsuranceButtons>
                <Button
                  variant={`${
                    activeCardSection === title ? "muted" : "muted-primary"
                  }`}
                  onClick={() => handleButtonClick(title)}
                  style={{ marginBottom: "16px" }}
                >
                  {buttonText}
                </Button>
                <S.CardActivateInsuranceDescription href={link} target="_blank">
                  {textlink}
                </S.CardActivateInsuranceDescription>
              </S.CardActivateInsuranceButtons>
            </S.CardActivateInsuranceContent>
          )
        )}
      </S.CardActivateInsuranceContentGroup>
      {CardActivateInsuranceItem.map(
        ({ title, content }) =>
          activeCardSection === title && (
            <div style={{ width: "100%" }} key={title}>
              {content}
            </div>
          )
      )}
    </S.CardActivateInsuranceContainer>
  );
};

export default CardActivateInsurance;

CardActivateInsurance.propTypes = {
  CardActivateInsuranceItem: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.element.isRequired,
      title: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      textlink: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
};
